"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ShieldAlert, ArrowRight, SquareCheck as CheckSquare } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Guidance() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="afterarrivalguidance" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: "easeOut"
      }} className="bg-card text-card-foreground border border-border p-6 sm:p-10 md:p-12 relative overflow-hidden">
          {/* Top mechanical spec marker bar */}
          <div className="flex items-center justify-between border-b border-border pb-4 mb-8 text-xs font-mono uppercase tracking-widest text-muted-foreground">
            <div className="flex items-center gap-2">
              <ShieldAlert className="size-4 text-primary shrink-0" />
              <span>Inspection &amp; Setup Directive</span>
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <span>Ref: SEC-04-ARR</span>
            </div>
          </div>

          <div className="space-y-6">
            <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold uppercase tracking-wide text-foreground">
              After the Mechanical Bull Arrives
            </h2>

            <div className="space-y-4 text-muted-foreground text-base sm:text-lg leading-relaxed font-sans">
              <p>
                Delivery is not the same as installation. Before operating the machine, identify all included components and review the setup information available for the exact product.
              </p>
              <p>
                Confirm the controller, inflatable, blower, cables and other equipment before beginning setup. In addition, check the product-specific power, space and operating information.
              </p>
            </div>

            {/* Checklist highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2 pb-4 font-mono text-xs uppercase tracking-wider text-muted-foreground border-t border-border/60">
              <div className="flex items-center gap-2">
                <CheckSquare className="size-4 text-primary shrink-0" />
                <span>Verify all crates &amp; power packs</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckSquare className="size-4 text-primary shrink-0" />
                <span>Validate perimeter clearance</span>
              </div>
            </div>

            <div className="pt-2">
              <Button asChild size="lg" className="rounded-none bg-primary text-primary-foreground font-mono uppercase tracking-wider text-xs sm:text-sm font-semibold hover:bg-primary/90 active:scale-[0.99] transition-[background-color,transform] duration-150 shadow-none px-6 py-3 h-auto">
                <Link to="/SetupSafetyAndMaintenancePage">
                  <span>Read the Setup &amp; Safety Guide</span>
                  <ArrowRight className="size-4 ml-2" />
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}